import { ReviewTileItem } from "@/types/tile.types";

export const useTileTextExtraction = () => {
    const getSearchableText = (
        item: ReviewTileItem,
        selectedOptionsForReview?: Array<{ name: string; code: string }>
    ): string => {
        if (!item.originalData) return "";

        const query = item.query || "";
        const extraData = item.originalData;

        const COMPARE_PRECEDENT_SUB_OPTIONS = [
            "additional-clauses",
            "unfavorable-terms",
            "missing-clauses",
            "general-comparison",
            "legislation-check",
            "inconsistencies",
        ];

        const isComparePrecedentSelected = selectedOptionsForReview?.some(
            (opt) => opt.code === `compare-precedent-${query}`
        );
        const isComparePrecedentTile =
            isComparePrecedentSelected && COMPARE_PRECEDENT_SUB_OPTIONS.includes(query);

        const finalQuery = isComparePrecedentTile ? `compare-precedent-${query}` : query;

        switch (finalQuery) {
            case "risk-analysis":
                return extraData?.riskText || "";
            case "ambiguities":
                return extraData?.ambiguousText || "";
            case "complex-language":
                return extraData?.complexText || "";
            case "custom-review":
                return extraData?.relevantText || "";
            case "conflicting-terms":
                return extraData?.clause1?.relevant_text || "";
            case "find-placeholders":
                return extraData?.placeholder || "";
            case "inconsistencies":
                return extraData?.text1 || extraData?.text2 || "";
            case "missing-clauses":
                return extraData?.insertionPoint || "";
            case "non-standard-clauses":
                return extraData?.nonStandardText || "";
            case "points-to-negotiate":
                return extraData?.negotiationText || "";
            case "cross-referencing-clauses":
                return extraData?.context || "";
            case "sequential-order":
                return extraData?.context || "";
            case "undefined-terms":
                return extraData?.contextText || "";
            case "compare-precedent-additional-clauses":
                return extraData?.additionalClause || "";
            case "compare-precedent-missing-clauses":
                return extraData?.otherText || extraData?.missingClause || "";
            case "compare-precedent-unfavorable-terms":
                return extraData?.otherText || "";
            case "compare-precedent-legislation-check":
                return extraData?.legislationText || "";
            case "compare-precedent-general-comparison":
                return extraData?.otherText || "";
            case "compare-precedent-inconsistencies":
                return extraData?.precedentText || extraData?.otherText || "";
            default:
                return "";
        }
    };

    const normalizeSearchText = (text: string): string => {
        if (!text || typeof text !== "string") return "";
        return text
            .trim()
            .replace(/["“”]/g, "") // Remove straight and curly quotes
            .replace(/\s+/g, " ")
            .replace(/\n+/g, "\n")
            .replace(/\t+/g, " ");
    };

    return {
        getSearchableText,
        normalizeSearchText,
    };
};
